import React from "react";
import ReusableForm from "./ReusableForm";

const ReusableFormWrapper = ({
  selectedTemplate,
  formData,
  handleInputChange,
  validationErrors,
  fieldRefs,
}) => {
  const aLetterFields = [
    {
      name: "alias",
      label: "Greeting First Name(s)",
      tooltip: "Max 25 characters", 
      group: "prospectsQueryParams",
      required: true,
      maxLength: 25,
    },
    {
      name: "qrCodeContent",
      label: "Redirect to Landing page",
      group: "prospectsQueryParams",
      placeholder: "https://example.com",
      required: true,
    },
    {
      name: "id",
      label: "ID",
      group: "prospectsQueryParams",
      required: true,
    },
    {
      name: "realtor_info",
      label: "Realtor Name",
      tooltip: "Max 35 characters",
      group: "customerQueryParams",
      required: true,
      maxLength: 35,
    },
    {
      name: "sigline1",
      label: "Name with Designation",
      tooltip: "Max 45 characters",
      group: "customerQueryParams",
      required: true,
      maxLength: 45,
    },
    {
      name: "sigline2",
      label: "Company Name",
      tooltip: "Max 25 characters",
      group: "customerQueryParams",
      required: false,
      maxLength: 25,
    },
    {
      name: "sigline3",
      label: "Realtor's License#",
      tooltip: "Max 25 characters",
      group: "customerQueryParams",
      required: false,
      maxLength: 25,
    },

    {
      name: "sigline4",
      label: "Realtor's Email",
      tooltip: "Max 45 characters",
      group: "customerQueryParams",
      required: true,
      maxLength: 45,
    },
    {
      name: "cta1",
      label: "Realtor's First Name to Call",
      tooltip: "Max 10 characters",
      group: "customerQueryParams",
      required: true,
      maxLength: 10,
    },
    {
      name: "cta2",
      label: "Call back Phone Number",
      tooltip: "Max 15 characters",
      group: "customerQueryParams",
      required: true,
      maxLength: 15,
    },
    {
      name: "city",
      label: "Campaign Target Area",
      group: "campaignQueryParams",
      required: true,
    },
    {
      name: "buyer_names",
      label: "Buyer's Name(s)",
      group: "campaignQueryParams",
      required: true,
    },
  ];

  const envelopeFields = [
    {
      name: "alias",
      label: "Name(s) on the Envelope",
      group: "prospectsQueryParams",
      required: true,
      maxLength: 35, 
      tooltip: "Max 35 characters",

    },
    {
      name: "address1",
      label: "Street",
      group: "prospectsQueryParams",
      required: true,
    },
    {
      name: "city",
      label: "City",
      group: "prospectsQueryParams",
      required: true,
    },
    {
      name: "state",
      label: "State",
      group: "prospectsQueryParams",
      required: true,
    },
    {
      name: "zip",
      label: "ZIP Code",
      group: "prospectsQueryParams",
      required: true,
    },
    {
      name: "id",
      label: "ID",
      group: "prospectsQueryParams",
      required: true,
    },
    {
      name: "return_address_line1",
      label: "Address Line 1",
      group: "envelopeCustomerQueryParams",
      required: false,
    },
    {
      name: "return_address_line2",
      label: "Address Line 2",
      group: "envelopeCustomerQueryParams",
      required: false,
    },
  ];

   const cashOfferFields = [
    {
      name: "alias",
      label: "Greeting First Name(s)",
      tooltip: "Max 25 characters", 
      group: "prospectsQueryParams",
      required: true,
      maxLength: 25,
    },
    {
      name: "qrCodeContent",
      label: "Redirect to Landing page",
      group: "prospectsQueryParams",
      placeholder: "https://example.com",
      required: true,
    },
    {
      name: "id",
      label: "ID",
      group: "prospectsQueryParams",
      required: true,
    },
    {
      name: "realtor_info",
      label: "Realtor Name",
      tooltip: "Max 35 characters",
      group: "customerQueryParams",
      required: true,
      maxLength: 35,
    },
    {
      name: "sigline1",
      label: "Name with Designation",
      tooltip: "Max 45 characters",
      group: "customerQueryParams",
      required: false,
      maxLength: 45,
    },
    {
      name: "sigline2",
      label: "Company Name",
      tooltip: "Max 25 characters",
      group: "customerQueryParams",
      required: false,
      maxLength: 25,
    },
    {
      name: "sigline3",
      label: "Realtor's License#",
      tooltip: "Max 25 characters",
      group: "customerQueryParams",
      required: false,
      maxLength: 25,
    },

    {
      name: "sigline4",
      label: "Realtor's Email",
      tooltip: "Max 45 characters",
      group: "customerQueryParams",
      required: false,
      maxLength: 45,
    },
    {
      name: "cta1",
      label: "Realtor's First Name to Call",
      tooltip: "Max 10 characters",
      group: "customerQueryParams",
      required: true,
      maxLength: 10,
    },
    {
      name: "cta2",
      label: "Call back Phone Number",
      tooltip: "Max 15 characters",
      group: "customerQueryParams",
      required: true,
      maxLength: 15,
    },

  ];
 
    let fields;
    fields = 
    selectedTemplate === "Envelope #10"
    ? envelopeFields
    : selectedTemplate.includes("Agent Letter")
    ? aLetterFields
    : cashOfferFields;

  return (
    <ReusableForm
      fields={fields}
      values={formData[selectedTemplate]}
      onChange={handleInputChange}
      validationErrors={validationErrors}
      refs={fieldRefs}
    />
  );
};

export default ReusableFormWrapper;
